import { _b64ch } from "./constants";

export const Base64 = {
  encode(str: string) {
    for (let i = 0, j = 0, a = 0, b = ""; ; i += 1) {
      if (i < str.length) {
        const ch = str.charCodeAt(i);

        for (a = (((a << 8) | (ch & 255)) << 8) | (ch >> 8), j += 16; j > 5; ) {
          b += _b64ch[(a >>> (j -= 6)) & 63];
        }

        continue;
      }

      if (j) {
        b += _b64ch[(a << (6 - j)) & 63];
      }

      while (b.length & 3) {
        b += "=";
      }

      return b;
    }
  },
};
